// extracted by mini-css-extract-plugin
export default {"TopSection":"NotJustSection_TopSection__aJrIO","LeftSection":"NotJustSection_LeftSection__yUH6+","RightSection":"NotJustSection_RightSection__gfVp6"};